export default "__VITE_ASSET__D2j_if_t__"